<div
	class="rounded p-4 flex flex-col items-center justify-center gap-4 mt-4"
	*ngIf="showEmptyState && isEditable"
>
	<app-icon [icon]="ICON.CONTACT_INFO"></app-icon>
	<p class="text-grey-dark mt-2">
		No contact details added for this {{ contactType }}
	</p>
	<p class="font-bold cursor-pointer" (click)="editContactDetails()">
		Edit {{ contactType }}
	</p>
</div>
<div class="grid grid-cols-2 gap-2" *ngIf="!showEmptyState">
	<ng-container
		*ngIf="contactDetails?.email"
		[ngTemplateOutlet]="template"
		[ngTemplateOutletContext]="{
			email: contactDetails?.email,
			icon: ICON.EMAIL,
			isOnlyOfType: !contactDetails.email2,
		}"
	></ng-container>
	<ng-container
		*ngIf="contactDetails?.email2"
		[ngTemplateOutlet]="template"
		[ngTemplateOutletContext]="{
			email: contactDetails?.email2,
			icon: ICON.EMAIL,
			isOnlyOfType: !contactDetails.email,
		}"
	></ng-container>
	<ng-container
		*ngIf="contactDetails?.phone"
		[ngTemplateOutlet]="template"
		[ngTemplateOutletContext]="{
			href: 'tel:' + contactDetails?.phone,
			value: contactDetails?.phone,
			icon: ICON.PHONE,
			isOnlyOfType: !contactDetails?.phone2,
		}"
	></ng-container>
	<ng-container
		*ngIf="contactDetails?.phone2"
		[ngTemplateOutlet]="template"
		[ngTemplateOutletContext]="{
			href: 'tel:' + contactDetails?.phone2,
			value: contactDetails?.phone2,
			icon: ICON.PHONE,
			isOnlyOfType: !contactDetails?.phone,
		}"
	></ng-container>
	<ng-container
		*ngIf="contactDetails?.fax"
		[ngTemplateOutlet]="template"
		[ngTemplateOutletContext]="{
			value: contactDetails?.fax,
			icon: ICON.FAX,
			isOnlyOfType: true,
		}"
	></ng-container>
</div>

<ng-template
	#template
	let-href="href"
	let-value="value"
	let-icon="icon"
	let-isOnlyOfType="isOnlyOfType"
	let-email="email"
>
	<div [class.col-span-2]="isOnlyOfType">
		<div class="text-grey flex items-center gap-2">
			<app-icon [icon]="icon"></app-icon>

			<span
				*ngIf="href || email; else noHrefTemplate"
				class="hover:text-green hover:underline break-all text-sm"
			>
				<a
					*ngIf="href"
					externalNavInterceptor
					[href]="href"
					target="_blank"
					class="cursor-pointer"
				>
					{{ value }}
				</a>
				<a
					*ngIf="email"
					emailLinkInterceptor
					class="cursor-pointer"
					href="mailto:{{ email }}?subject={{ emailSubject$ | async }}"
					target="_blank"
				>
					{{ email }}
				</a>
			</span>

			<ng-template #noHrefTemplate>
				<span class="break-all text-sm">{{ value }}</span>
			</ng-template>

			<app-icon
				(click)="copyToClipboard(value || email)"
				[icon]="ICON.COPY"
				class="cursor-pointer"
			></app-icon>
		</div>
	</div>
</ng-template>

<ng-template *emailLink> </ng-template>
